import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import { WorklistTaskFormData } from '~/scenes/PeopleModule/components/Tabs/CollaborationTab/WorklistTable/EditWorklistTaskDialog/data';

export const useWorklistTaskValidation = () => {
  const { t } = useTranslation();

  const validationSchema = useMemo(() => {
    const requiredFieldMessage = t('fieldIsRequired');

    return yup.object().shape<WorklistTaskFormData>({
      title: yup
        .string()
        .required(requiredFieldMessage)
        .min(1, requiredFieldMessage),
      description: yup.string(),
      link: yup.string().url(t('laNotValidURL')).default(''),
      targetEmployeeId: yup
        .number()
        .integer()
        .required(requiredFieldMessage)
        .min(0, requiredFieldMessage),
      creatorEmployeeId: yup.number().integer().required(requiredFieldMessage),
      taskType: yup.string(),
      taskStatus: yup.string(),
      attachmentId: yup.number(),
      attachmentName: yup.string(),
      attachmentIsArchived: yup.boolean(),
    });
  }, [t]);

  return {
    validationSchema,
  };
};
